module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth d-flex bg-lightest"
  }, [(_vm.file.length > 0) ? _c(_vm.file, {
    tag: "component"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "d-flex justify-content-end align-items-center mt-5 mr-4"
  }, [_c('div', {
    staticClass: "dark bold mr-3"
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('router-link', {
    staticClass: "btn outlined action wide",
    attrs: {
      "to": {
        name: _vm.path
      },
      "tag": "div"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.button) + "\n            ")])], 1), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('modal-wrapper')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-38d80f27", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38d80f27"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Auth.vue
// module id = 1356
// module chunks = 0